import(/* webpackMode: "eager" */ "/home/runner/work/pen-man/pen-man/app/[locale]/(externalroutes)/login/page.tsx");
